var exports = {
  "N": "x43aef4ae--279221--element",
};

module.exports = exports;
